export enum COACH_SORT {
  NAME = 'name',
  EMAIL = 'email',
  LAST_LOGIN_AT = 'lastLoginAt',
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
}
